import { FC, ReactNode, createContext, useState, useContext } from 'react';
import { Locale } from 'translations';

export interface TranslationContextType {
    translate: Function;
    setTranslate: (value: Function) => void;
    locale: keyof typeof Locale;
    setLocale: (value: keyof typeof Locale) => void;
}

interface TranslationContextProps {
    children?: ReactNode;
}

const defaultValue: TranslationContextType = {
    translate: () => (value: string) => value,
    setTranslate: () => undefined,
    locale: 'en',
    setLocale: () => undefined
};

const TranslationContext = createContext<TranslationContextType>(defaultValue);

export const TranslationContextProvider: FC = (props: TranslationContextProps) => {
    const [translate, setTranslate] = useState<Function>(defaultValue.translate);
    const [locale, setLocale] = useState<keyof typeof Locale>(defaultValue.locale);

    return (
        <TranslationContext.Provider
            value={{
                translate,
                setTranslate,
                locale,
                setLocale
            }}
        >
            {props.children}
        </TranslationContext.Provider>
    );
};

export const useTranslationContext: () => TranslationContextType = () => useContext(TranslationContext);
